import {AuditCategoryOfStructure} from '../../../types/AuditCategoryOfStructure';
import {AuditCategoryUniqueKeyLiteral} from '../types/AuditCategoryUniqueKey';

export const findCategoryByUniqueKey = (
  category: AuditCategoryOfStructure | undefined,
  uniqueKey: AuditCategoryUniqueKeyLiteral
): AuditCategoryOfStructure | undefined =>
  category?.childCategories?.find((category) => category.uniqueKey === uniqueKey);
